import type { EntryPoint, Shell } from '#packages/apilib';

import { EditorAPIKey } from '#packages/apis';
import {
  aiHtmlSectionReducer,
  type AiHtmlSectionState,
  type AiHtmlSectionActions,
} from '../state';
import { AiHtmlSectionUIApiKey } from './publicApiKey';
import { createAiHtmlSectionUIApi } from './createAiHtmlSectionUIApi';
import { AiHtmlPromptApiKey } from '../aiHtmlPromptApi/publicApiKey';

export const AiHtmlSectionUIApiEntryPoint: EntryPoint = {
  name: 'AiHtmlSectionUIApiEntryPoint',
  getDependencyAPIs: () => [EditorAPIKey, AiHtmlPromptApiKey],
  declareAPIs: () => [AiHtmlSectionUIApiKey],
  attach(shell: Shell) {
    shell.contributeAPI(AiHtmlSectionUIApiKey, () =>
      createAiHtmlSectionUIApi(shell),
    );
    shell.contributeState<
      { aiHtmlSection: AiHtmlSectionState },
      AiHtmlSectionActions
    >(() => ({
      aiHtmlSection: aiHtmlSectionReducer,
    }));
  },
};
